import {
  RichiestaDTO,
  getGetFrontAreaPubblicaRichiesteIdQueryOptions,
  getGetFrontRichiesteIdQueryOptions,
  useGetQuery,
} from '@framework/api-client';
import { useMemo } from 'react';
import { UseQueryResult } from 'react-query';
import { useLocation } from 'react-router';
import { isPublicSubmission } from '../isPublicSubmission';

/**
 * Ritorna l'API corretta da chiamare in base al path fornito.
 * Nel caso di un path che contiene 'osservazioni' ritorna l'endpoint per le richieste pubbliche.
 * Altrimenti, ritorna l'endpoint per le richieste dell'utente.
 */
function getSubmissionEndpoint(path: string) {
  if (isPublicSubmission(path)) {
    // GET/area-pubblica/richieste/{id}
    return getGetFrontAreaPubblicaRichiesteIdQueryOptions;
  }

  // GET/richesta/{id}
  return getGetFrontRichiesteIdQueryOptions;
}

/**
 * Ritorna la richiessta in base all'id fornito, richiamando l'API
 * "privata" se si sta guardando una propria richiesta, o quella "pubblica"
 * se si cerca una richiesta pubblica. Il risultato dipende dall'URL in cui
 * ci si trova.
 */
export function useControlledAccessSubmission(
  submissionId: string | null | undefined,
) {
  const location = useLocation();

  const queryOptions = useMemo(
    () => getSubmissionEndpoint(location.pathname),
    [location.pathname],
  );

  const submissionRequest: UseQueryResult<RichiestaDTO | undefined> =
    useGetQuery(queryOptions, [
      submissionId!,
      {
        query: {
          keepPreviousData: true,
          enabled: Boolean(submissionId),
          // Trasformo il risultato con l'oggetto RichiestaDTO, uguale per entrambe le possibili chiamate
          select: (data: any) => {
            if (!data) return data;
            if ('richiesta' in data) {
              return (data.richiesta ?? undefined) as RichiestaDTO | undefined;
            }
            return data;
          },
        },
      },
    ]);

  return submissionRequest;
}
